import { NormalButton, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export const EmptyView = ({ onClick }: { onClick?: () => void }) => {
  return (
    <Container>
      <Text variant='Body_16_Bold' color='textStrong'>
        실측 정보가 아직 없어요
      </Text>
      <Text variant='Body_14_Regular' color='textTertiary'>
        판매자에게 문의해 보세요.
      </Text>
      <Button size='small' onClick={onClick}>
        사이즈 문의하기
      </Button>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 32px 0 52px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${vars.color.staticWhite};
  gap: 6px;
`;

const Button = styled(NormalButton)`
  margin-top: 14px;
`;
